import { createApi, EndpointBuilder } from "@reduxjs/toolkit/query/react";
import { Employee } from "@src/types";
import { message } from "antd";

import { createFetchBaseQuery } from "./baseQuery";
import { baseApiSlice } from "./baseApiSlice";

export const usersApi = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* GET endpoints */
    ...getEndpoints(builder),
  }),
});

function getEndpoints(builder: EndpointBuilder<any, any, any>) {
  return {
    /**
     * Get loggedIn user
     */
    getLoggedInUser: builder.query<Employee, void>({
      query: () => "/user",
      transformErrorResponse: async (): Promise<void> => {
        message.error("Unable to load logged in user", 5);
      },
    }),

    /**
     * Get photo of loggedIn user
     */
    getPhotoLoggedInUser: builder.query<string, void>({
      query(args) {
        return {
          url: `https://graph.microsoft.com/v1.0/me/photo/$value`,
          responseHandler: async (response) => {
            const url = window.URL || window.webkitURL;
            return url.createObjectURL(await response.blob());
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
    }),
  };
}

export const {
  /*GET endpoints */
  useGetLoggedInUserQuery,
  useLazyGetLoggedInUserQuery,
  useGetPhotoLoggedInUserQuery,
} = usersApi;
